(function(){
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* Reveal au scroll */
  function initReveals(){
    var els = document.querySelectorAll('.pod-reveal:not(.is-in)');
    if(reduce){ els.forEach(function(e){e.classList.add('is-in')}); return; }
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('is-in')}); return; }
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    },{threshold:0.12, rootMargin:'0px 0px -40px 0px'});
    els.forEach(function(e){ io.observe(e); });
  }

  /* Stagger : applique un delai aux enfants .pod-stagger > * */
  function initStagger(){
    document.querySelectorAll('.pod-stagger').forEach(function(group){
      Array.prototype.slice.call(group.children).forEach(function(child,i){
        child.style.setProperty('--pod-delay', (i*0.08)+'s');
      });
    });
  }

  /* Header : devient solide au scroll */
  function initHeaderState(){
    var header = document.querySelector('.pod-topbar') || document.querySelector('header-component') || document.querySelector('header');
    if(!header) return;
    function onScroll(){
      if(window.scrollY > 40) header.classList.add('pod-scrolled');
      else header.classList.remove('pod-scrolled');
    }
    onScroll();
    window.addEventListener('scroll', onScroll, {passive:true});
  }

  function boot(){ initStagger(); initReveals(); initHeaderState(); }
  if(document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  /* Re-init dans l'editeur de theme Shopify */
  document.addEventListener('shopify:section:load', function(){ initStagger(); initReveals(); });
})();


/* ===== POD3D_V2 : galerie vivante (tilt 3D, parallax, mots) ===== */
(function(){
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var coarse = window.matchMedia('(pointer:coarse)').matches;

  /* 1) Auto-tag : ajoute la profondeur 3D aux cartes/visuels natifs */
  function autoTag(){
    // Scene + reveal 3D sur les sections POD
    document.querySelectorAll('.pod-section, .shopify-section').forEach(function(s){
      s.classList.add('pod-scene');
    });
    // Cartes produit natives Horizon -> lift + tilt
    document.querySelectorAll('.product-card, [class*="product-card"], .card-gallery').forEach(function(c){
      if(!c.classList.contains('pod-lift')) c.classList.add('pod-lift');
    });
    // Visuels POD (cartes artistes, activites, textile, badges) -> tilt
    document.querySelectorAll('.pod-artist, .pod-activity, .pod-card, .pod-textile__visual, .pod-invest__badge, .pod-pinvest__inner, .pp-card, .pp-quote, .pod-visit__cell').forEach(function(c){
      if(!c.classList.contains('pod-tilt')){ c.classList.add('pod-tilt'); }
    });
    // Grands titres : reveal + glitch d'entree
    document.querySelectorAll('.pod-h2, .pod-discovery__title, .pod-textile__title').forEach(function(t){
      if(!t.classList.contains('pod-reveal') && !t.closest('.pod-reveal') && !t.closest('.pod-reveal-3d')){
        t.classList.add('pod-reveal');
      }
    });
  }

  /* 2) Tilt 3D interactif suivant la souris */
  function initTilt(){
    if(reduce || coarse) return;
    var MAX = 9; // degres
    document.querySelectorAll('.pod-tilt:not([data-tilt-ready])').forEach(function(el){
      el.setAttribute('data-tilt-ready','1');
      // shine layer
      if(getComputedStyle(el).position === 'static') el.style.position='relative';
      if(!el.querySelector('.pod-tilt__shine')){
        var sh=document.createElement('span'); sh.className='pod-tilt__shine'; el.appendChild(sh);
      }
      var raf=null, tx=0, ty=0;
      function move(e){
        var r=el.getBoundingClientRect();
        var px=(e.clientX-r.left)/r.width, py=(e.clientY-r.top)/r.height;
        tx=(0.5-py)*MAX*2; ty=(px-0.5)*MAX*2;
        el.style.setProperty('--mx',(px*100)+'%'); el.style.setProperty('--my',(py*100)+'%');
        if(!raf) raf=requestAnimationFrame(apply);
      }
      function apply(){
        raf=null;
        el.style.transform='perspective(900px) rotateX('+tx.toFixed(2)+'deg) rotateY('+ty.toFixed(2)+'deg) translateZ(0)';
      }
      el.addEventListener('pointerenter',function(){ el.classList.add('is-tilting'); el.setAttribute('data-tilting','1'); });
      el.addEventListener('pointermove',move);
      el.addEventListener('pointerleave',function(){
        el.classList.remove('is-tilting'); el.setAttribute('data-tilting','0');
        el.style.transform='';
      });
    });
  }

  /* 3) Parallax au scroll (elements .pod-parallax, vitesse via data-speed) */
  function initParallax(){
    if(reduce) return;
    var items=[].slice.call(document.querySelectorAll('.pod-parallax'));
    if(!items.length) return;
    var ticking=false;
    function update(){
      ticking=false;
      var vh=window.innerHeight;
      items.forEach(function(el){
        var r=el.getBoundingClientRect();
        if(r.bottom<-200||r.top>vh+200) return;
        var speed=parseFloat(el.getAttribute('data-speed'))||0.12;
        var center=r.top+r.height/2-vh/2;
        el.style.setProperty('--pod-py',(-center*speed).toFixed(1)+'px');
      });
    }
    window.addEventListener('scroll',function(){ if(!ticking){ ticking=true; requestAnimationFrame(update); } },{passive:true});
    window.addEventListener('resize',update,{passive:true});
    update();
  }

  /* 4) Auto-parallax doux sur les images de hero/visuels POD */
  function autoParallax(){
    if(reduce) return;
    document.querySelectorAll('.pod-hero__media img, .pod-textile__visual img, .pod-visit__media img').forEach(function(img){
      if(!img.classList.contains('pod-parallax')){ img.classList.add('pod-parallax'); img.setAttribute('data-speed','0.08'); }
    });
  }

  /* 5) Decoupe des titres .pod-words en mots animes */
  function initWords(){
    document.querySelectorAll('.pod-words:not([data-words-ready])').forEach(function(el){
      el.setAttribute('data-words-ready','1');
      var txt=el.textContent.trim(); el.textContent='';
      txt.split(/(\s+)/).forEach(function(part){
        if(/^\s+$/.test(part)){ el.appendChild(document.createTextNode(' ')); return; }
        var sp=document.createElement('span'); sp.className='pod-word'; sp.textContent=part; el.appendChild(sp);
      });
      [].slice.call(el.querySelectorAll('.pod-word')).forEach(function(w,i){ w.style.setProperty('--pod-wi',i); });
    });
    if(reduce){ document.querySelectorAll('.pod-words').forEach(function(e){e.classList.add('is-in')}); return; }
    if(!('IntersectionObserver' in window)){ document.querySelectorAll('.pod-words').forEach(function(e){e.classList.add('is-in')}); return; }
    var io=new IntersectionObserver(function(ents){ents.forEach(function(en){if(en.isIntersecting){en.target.classList.add('is-in');io.unobserve(en.target);}});},{threshold:0.2});
    document.querySelectorAll('.pod-words:not(.is-in)').forEach(function(e){io.observe(e);});
  }

  function boot3d(){ autoTag(); autoParallax(); initTilt(); initParallax(); initWords(); }
  if(document.readyState!=='loading') boot3d();
  else document.addEventListener('DOMContentLoaded', boot3d);
  document.addEventListener('shopify:section:load', boot3d);
  // re-tag apres chargement differé d'images/produits
  window.addEventListener('load', function(){ setTimeout(boot3d,300); });
})();

/* POD_FAILSAFE : garantit que rien ne reste invisible (filets de securite) */
(function(){
  function revealAll(){
    document.querySelectorAll('.pod-reveal:not(.is-in),.pod-reveal-3d:not(.is-in),.pod-words:not(.is-in)').forEach(function(e){e.classList.add('is-in');});
  }
  // si IntersectionObserver n'a rien declenche apres 2.6s, on revele tout
  setTimeout(revealAll, 2600);
  window.addEventListener('load', function(){ setTimeout(revealAll, 1800); });
})();


/* ===== POD UI PRO : barre de progression de lecture ===== */
(function(){
  'use strict';
  if(window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
  function init(){
    if(document.getElementById('pod-progress')) return;
    var bar = document.createElement('div');
    bar.id = 'pod-progress';
    document.body.appendChild(bar);
    var ticking = false;
    function update(){
      ticking = false;
      var h = document.documentElement;
      var max = h.scrollHeight - h.clientHeight;
      var p = max > 0 ? (h.scrollTop || document.body.scrollTop) / max : 0;
      bar.style.setProperty('--pod-progress', p.toFixed(4));
    }
    window.addEventListener('scroll', function(){ if(!ticking){ ticking = true; requestAnimationFrame(update); } }, {passive:true});
    window.addEventListener('resize', update, {passive:true});
    update();
  }
  if(document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
